import { useMemo } from 'react'

import type { DateRange } from 'react-day-picker'
import { useQuery } from 'react-query'

import { Creator } from '@/modules/creators/types.ts'
import { trackingService } from '@/modules/tracking/chatter-tracking/service/chatter-tracking-service.ts'
import { handleError } from '@/utils/error'

export const useChatterInspectData = (
  activeCreator: Creator | undefined,
  dateRange: DateRange | undefined,
  userId: number | undefined,
  browserName: string | undefined,
  hourly: boolean,
) => {
  const { data, isFetching, isIdle, refetch } = useQuery(
    ['tracking', dateRange, activeCreator, userId, browserName, hourly],
    async () => {
      return await trackingService.findInspectByNameAndDate(
        activeCreator!.id,
        userId,
        browserName,
        dateRange!.from || new Date(),
        dateRange!.to || new Date(),
        hourly,
      )
    },
    {
      enabled: !!activeCreator && !!dateRange && (!!browserName || !!userId),
      onError: (error) =>
        handleError(error, 'Failed to get chatter inspection data', refetch),
    },
  )

  return useMemo(
    () => ({
      data,
      isFetching: isFetching || isIdle,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, isFetching, isIdle, activeCreator],
  )
}
